module.exports = __webpack_public_path__ + "resources/img/img_sectigo_ssl2.cecf1cc2a41c87309ca2a990e63bac7d.png";